import { Box, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { Colors, MobilePadding } from 'pages';
import styled from 'styled-components';
import { ContainerMaxWidth } from './organisms/layouts/Layout';
import { FC } from 'react';
const TRUST = ['200+ dealership rooftops using our tools in 32 states, representing every brand', `EVs and PHEVs. New and Used. If it’s electric, Lectrium helps sell it`, 'Best-in-class data on EV specifications, federal guidelines and state programs updated in real time'];
export const Trusted: FC<{
  points?: Array<string>;
}> = ({
  points = TRUST
}) => {
  return <Box sx={{
    backgroundColor: Colors.White,
    mx: 'auto',
    maxWidth: ContainerMaxWidth,
    padding: {
      xs: MobilePadding,
      md: '96px 96px 36px 96px'
    }
  }}>
      <Box>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Typography sx={{
            fontSize: '38px',
            fontWeight: 700,
            lineHeight: {
              xs: 1,
              md: 1.5
            },
            mb: {
              xs: '1.5rem',
              md: '24px'
            }
          }}>
              Auto dealers trust Lectrium
            </Typography>

            <StyledUL>
              {points.map((item, i) => <li key={i} style={{
              marginBottom: '16px'
            }}>
                  <Typography sx={{
                fontSize: '16px',
                color: Colors.RiverBed
              }}>{item}</Typography>
                </li>)}
            </StyledUL>

            <StyledLink href={'/book-a-demo'} style={{
            color: Colors.White,
            marginTop: '32px',
            display: 'block',
            marginLeft: '24px',
            maxWidth: '175px',
            textAlign: 'center',
            fontWeight: 600,
            padding: '12px 16px 12px 16px',
            textTransform: 'none',
            textDecoration: 'none',
            fontFamily: 'Gilroy',
            borderRadius: '2px'
          }}>
              Meet Lectrium
            </StyledLink>
          </Grid>

          <Grid item xs={12} md={6} sx={{
          mt: {
            xs: '1rem',
            md: ''
          }
        }}>
            <Image src="/assets/images/usa-map-2.png" width={600} height={600} alt="" />
          </Grid>
        </Grid>
      </Box>
    </Box>;
};
const StyledLink = styled(Link)`
  background-color: #3547c5;

  :hover {
    background-color: #4759cb;
  }
`;
const StyledUL = styled.ul`
  > li:before {
    content: '•';
    font-size: 20px;
    color: #3547c5;
    display: block;
  }

  > li {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  list-style-type: none;
`;